import React from 'react'

import AuditList from './AuditList'

const AuditSearchResults = ({ list, handleReset }) =>
  <div className='audit-results usa-grid'>
    <h1>Audit Search Results</h1>
    <span className='records-found'>
      <h4>Records found: {list.length}</h4>
      <button onClick={handleReset}>New Search</button>
    </span>
    <div className='audit-results-list'>
      <AuditList list={list} />
    </div>
  </div>

export default AuditSearchResults